import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getBindingFromId, getPaymentOptionTypeFromId, getUngranularPaymentType } from "../../../components/PaymentContainer/components/PaymentSelection/components/PaymentMethodSection/Button/logic/utils";
import { findFirst } from "../../../../utils/arrays";
import { EStatus, SEPARATOR } from "../../../../constants";
export var getSubmitPayment = function getSubmitPayment(_ref) {
  var quickPaymentMap = _ref.quickPaymentMap,
    regularPaymentMap = _ref.regularPaymentMap;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var state, paymentId, paymentType, bindingId, isQuickPayment, ungranularType, handler;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            paymentId = state.selectedPaymentId;
            if (paymentId) {
              _context.next = 4;
              break;
            }
            throw new Error('no payment selected');
          case 4:
            _context.prev = 4;
            paymentType = getPaymentOptionTypeFromId(paymentId);
            bindingId = getBindingFromId(paymentId);
            isQuickPayment = paymentId.includes(SEPARATOR);
            ungranularType = paymentType && getUngranularPaymentType(paymentType);
            handler = findFirst([isQuickPayment && paymentType && bindingId && ungranularType && quickPaymentMap[ungranularType], paymentType && ungranularType && regularPaymentMap[ungranularType]]);
            if (handler) {
              _context.next = 12;
              break;
            }
            throw new Error("no payment handler found for ".concat(paymentId));
          case 12:
            _context.next = 14;
            return handler(getState, setState);
          case 14:
            return _context.abrupt("return", _context.sent);
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](4);
            console.error(_context.t0);
            return _context.abrupt("return", EStatus.Error);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 17]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};